import { TaskTypeConfigType } from '../../types';

export const defaultDataConfig: { [key: number]: TaskTypeConfigType } = {
    //['id' => 451, 'type' => 'task_type', 'name' => 'Action Item']
    451: {
        iconId: 521,
        taskTypeId: 451,
        defaultDuration: 30,
        defaultStartTime: '08:00:00',
        priority: 503,
        showBusy: true,
        reminder: 10, //min
    },
    //['id' => 452, 'type' => 'task_type', 'name' => 'Meeting'],
    452: {
        iconId: 522,
        taskTypeId: 452,
        defaultDuration: 60,
        defaultStartTime: '11:00:00',
        priority: 503,
        showBusy: true,
        reminder: 60, //min
    },
    //['id' => 453, 'type' => 'task_type', 'name' => 'Monitoring'],
    453: {
        iconId: 523,
        taskTypeId: 453,
        defaultDuration: 300,
        defaultStartTime: '12:00:00',
        priority: 502,
        showBusy: false,
        reminder: 0, //min
    },
    //['id' => 454, 'type' => 'task_type', 'name' => 'Supervision'],
    454: {
        iconId: 524,
        taskTypeId: 454,
        defaultDuration: 120,
        defaultStartTime: '14:00:00',
        priority: 504,
        showBusy: false,
        reminder: 0, //min
    },
    //['id' => 455, 'type' => 'task_type', 'name' => 'Inspection'],
    455: {
        iconId: 525,
        taskTypeId: 455,
        defaultDuration: 60,
        defaultStartTime: '12:00:00',
        priority: 502,
        showBusy: true,
        reminder: 0, //min
    },
    //['id' => 456, 'type' => 'task_type', 'name' => 'Milestone'],
    456: {
        iconId: 526,
        taskTypeId: 456,
        defaultDuration: 60,
        defaultStartTime: '12:00:00',
        priority: 502,
        showBusy: true,
        reminder: 0, //min
    },
    //['id' => 457, 'type' => 'task_type', 'name' => 'Unavailable'],
    457: {
        iconId: 527,
        taskTypeId: 457,
        defaultDuration: 60,
        defaultStartTime: '12:00:00',
        priority: 502,
        showBusy: true,
        reminder: 0, //min
    },
    //['id' => 458, 'type' => 'task_type', 'name' => 'Subtask'],
    458: {
        iconId: 528,
        taskTypeId: 458,
        defaultDuration: 60,
        defaultStartTime: '12:00:00',
        priority: 502,
        showBusy: true,
        reminder: 0, //min
    },
    //['id' => 459, 'type' => 'task_type', 'name' => 'Schedule'],
    459: {
        iconId: 529,
        taskTypeId: 459,
        defaultDuration: 60,
        defaultStartTime: '12:00:00',
        priority: 502,
        showBusy: true,
        reminder: 0, //min
    },
};
